import React from "react";
import { useSelector } from "react-redux";

const Heading = () => {
  const { search, author } = useSelector((state) => state.filter);
  return search !== "" || author !== "" ? (
    <div className='flex flex-col gap-4 max-w-7xl mx-auto px-5 mt-5 lg:px-0'>
      {search !== "" && (
        <div>
          <p className=' md:text-2xl '>
            Search Result For: <span className='font-semibold text-amber-600'>{search}</span>
          </p>
        </div>
      )}
      {author !== "" && (
        <div>
          <p className=' md:text-2xl'>
            Videos from: <span className='font-semibold  text-orange-600 '>{author}</span>
          </p>
        </div>
      )}
    </div>
  ) : null;
};

export default Heading;
